<div id="<%= dom_id age_cost %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Age:</strong>
    <%= age_cost.age_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Heat cost:</strong>
    <%= age_cost.heat_cost %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Solo cost:</strong>
    <%= age_cost.solo_cost %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Multi cost:</strong>
    <%= age_cost.multi_cost %>
  </div>
</div>
